// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TaskLoadingButton_wrapper__3pNCJ","content":"TaskLoadingButton_content__3GxqH","btn":"TaskLoadingButton_btn__JGvGK"};